import { PlaybackVideoJsPlayer } from '@app/core/video-player/PlaybackVideoJsPlayer';
import { VideoJsPlayerProps } from '@app/core/video-player/video-js/VideoJsPlayer';

const DEFAULT_OPTIONS: NonNullable<VideoJsPlayerProps['options']> = {
  inactivityTimeout: 0,
  /** Default `fluid` would reserve 16:9 height; audio-only only needs a short strip + controls. */
  fluid: false,
  width: '100%',
  height: 140,
  controlBar: {
    fullscreenToggle: false,
    pictureInPictureToggle: false,
    remainingTimeDisplay: false,
    currentTimeDisplay: true,
  },
};

export type VideoJsAudioPlayerProps = Omit<VideoJsPlayerProps, 'src'>;

/**
 * Video.js player preset for audio-only playback: control bar hides live/fullscreen/PiP,
 * keeps current time visible. `src` is supplied by the surrounding playback provider.
 */
export function VideoJsAudioPlayer({ options, ...rest }: VideoJsAudioPlayerProps) {
  return (
    <PlaybackVideoJsPlayer
      bordered
      playerClasses={['vjs-audio', 'vjs-normalise-time-controls']}
      sx={{ flex: '0 0 auto', width: '100%' }}
      options={{
        ...DEFAULT_OPTIONS,
        ...options,
      }}
      {...rest}
    />
  );
}
